"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.SidePageContent = void 0;
var _View = _interopRequireDefault(require("../View"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      overflowY: function overflowY(_ref) {
        var disableScroll = _ref.disableScroll;
        return disableScroll ? "hidden" : "scroll";
      },
      overflowX: "hidden" // for fix side page flickers on zoom 90% BO-18682
    },
    container: _defineProperty({
      height: "100%",
      flexDirection: "column",
      display: "flex",
      paddingTop: function paddingTop(_ref2) {
        var disableGutters = _ref2.disableGutters;
        return disableGutters ? 0 : "16px";
      },
      paddingLeft: function paddingLeft(_ref3) {
        var disableGutters = _ref3.disableGutters;
        return disableGutters ? 0 : "16px";
      },
      paddingRight: function paddingRight(_ref4) {
        var disableGutters = _ref4.disableGutters;
        return disableGutters ? 0 : "16px";
      },
      paddingBottom: function paddingBottom(_ref5) {
        var disableGutters = _ref5.disableGutters;
        return disableGutters ? 0 : "16px";
      }
    }, theme.breakpoints.up("md"), {
      paddingTop: function paddingTop(_ref6) {
        var disableGutters = _ref6.disableGutters;
        return disableGutters ? 0 : "24px";
      },
      paddingLeft: function paddingLeft(_ref7) {
        var disableGutters = _ref7.disableGutters;
        return disableGutters ? 0 : "24px";
      },
      paddingRight: function paddingRight(_ref8) {
        var disableGutters = _ref8.disableGutters;
        return disableGutters ? 0 : "24px";
      },
      paddingBottom: function paddingBottom(_ref9) {
        var disableGutters = _ref9.disableGutters;
        return disableGutters ? 0 : "24px";
      }
    })
  };
});
var dataCy = exports.dataCy = "SidePageContent";
var SidePageContent = exports.SidePageContent = function SidePageContent(_ref0) {
  var children = _ref0.children,
    className = _ref0.className,
    loading = _ref0.loading,
    fetching = _ref0.fetching,
    _ref0$disableGutters = _ref0.disableGutters,
    disableGutters = _ref0$disableGutters === void 0 ? false : _ref0$disableGutters,
    _ref0$disableScroll = _ref0.disableScroll,
    disableScroll = _ref0$disableScroll === void 0 ? false : _ref0$disableScroll;
  var classes = useStyles({
    disableGutters: disableGutters,
    disableScroll: disableScroll
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx["default"])(classes.root, className),
    "data-cy": dataCy,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
      loading: loading,
      fetching: fetching,
      position: fetching ? "relative" : "static",
      "data-cy-role": "sidePageContentView",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes.container,
        children: children
      })
    })
  });
};
SidePageContent.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].node]),
  className: _propTypes["default"].string,
  disableGutters: _propTypes["default"].bool,
  disableScroll: _propTypes["default"].bool,
  divider: _propTypes["default"].bool,
  loading: _propTypes["default"].bool
};